<template>
    <div class="row mb-5 justify-content-center mt-lg-0 mr-lg-1 ml-lg-1">
        <div class="d-none d-lg-block col-12 pt-lg-3 pt-2 pb-1 bl-bg">
            <span class="sb-title">Абонемент</span>
            <base-button class="mt-lg-0 sb-red-btn red-btn"
                         @click.stop="orderSelected"
                         :data-id="activeSubscription ? activeSubscription.idsubscription : null"
                         data-model="subscription"
                         :data-price="activeSubscription ? activeSubscription.price : null"
                         data-action="order"
                         :data-label="orderTitle">
                {{ orderTitle }}
            </base-button>
        </div>
        <div class="col-12 pt-lg-3 pt-2 bl-bg" v-for="(item, index) in subscriptions" :key="index">
            <SubscriptionItemCompact
                    :subscription="item"
                    :active="activeSubscriptions[index]"
                    :orderTitle="orderTitle"
                    @selected="selected"
                    @order="order"
                    @bonusCourseClick="bonusCourseClick"
            />
        </div>
        <div class="col-12 pt-lg-3 pt-2 pb-1 bl-bg" v-if="showBack">
            <div class="sb-back"
                 @click.stop="back">
                <i class="mdi-arrow-left"></i> ← {{ $t('back_to_list') }}
            </div>
        </div>
    </div>
</template>

<script>
    import SubscriptionItemCompact from "./SubscriptionItemCompact";
    import i18n from './../../i18n';

    export default {
        name: "SubscriptionsListCompact",
        components: {SubscriptionItemCompact},
        props: {
            timetable: {type: Object, default: null},
            subscriptions: {type: Array, default: null},
            orderTitle: {type: String, default: i18n.t('buy')},
            showBack: {type: Boolean, default: true},
        },

        data() {
            return {
                activeSubscriptions: [true],
                activeSubscription: null
            }
        },

        mounted() {
        },

        methods: {
            selected(subscription) {
                this.activeSubscription = subscription
                this.$emit("selected", subscription, this.timetable);
                this.setActive(subscription)
            },

            order(subscription) {
                this.$emit("order", subscription, this.timetable);
                this.setActive(subscription)
            },

            bonusCourseClick(subscription) {
                this.$emit("bonusCourseClick", subscription);
            },

            orderSelected() {
                let index = 0
                for (let isActive of this.activeSubscriptions) {
                    if (isActive)
                        break
                    else
                        index++;
                }

                let subscription = this.subscriptions[index]
                this.activeSubscription = subscription
                this.order(subscription)
            },

            back() {
                this.$emit("back");
            },

            setActive(subscription) {
                this.activeSubscriptions = []
                let index = 0;
                for (let sub of this.subscriptions) {
                    this.activeSubscriptions[index] = subscription.idsubscription === sub.idsubscription
                    index++;
                }
            }

        },

        watch: {
            subscriptions(subs) {
                console.log('subs', subs)
                if (subs) {
                    //Если ни одна пописка не активна, делаем активной первую
                    let activeCount = 0;
                    for (let sub of subs) {
                        if (sub.active) {
                            this.activeSubscription = sub
                            activeCount++;
                        }
                    }
                    if (activeCount === 0 && subs.length > 0) {
                        subs[0].active = true
                        this.activeSubscription = subs[0]
                    }
                }
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 991.8px) {
        .bl-bg:first-child {
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }

        .bl-bg:last-child {
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;
        }
    }

    .sb-back {
        color: #5ab947;
        font-family: Manrope Bold;
        display: inline-block;
        border: 1px solid #5ab947;
        font-size: 16px;
        line-height: 30px;
        border-radius: 24px;
        padding-left: 30px;
        padding-right: 30px;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 20px;
        opacity: 0.8;
        cursor: pointer;
    }

    .sb-back:hover {
        opacity: 1;
    }

    .red-btn {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        border-radius: 30px;
        color: #231c37;
        font-family: "Manrope Bold";
        position: absolute;
        width: 120px !important;
        right: 10px;
        top: 16px;
        font-size: 16px;
        line-height: 16px;
        padding-left: 0;
        padding-right: 0;
    }

    .red-btn:disabled, .red-btn.btn-default:disabled:hover {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        opacity: 0.8;
        color: rgba(35, 28, 55, 0.55);
        text-shadow: none;
    }

    .red-btn, .red-btn.btn-default:hover {
        background-color: #de0035;
        border-color: #de0035;
        color: white;
        text-shadow: 1px 1px 2px #97191e;
    }

    .sb-title {
        font-family: "Manrope Bold";
        color: #231c37;
        font-size: 24px;
        margin-left: 5px;
    }

    .bl-bg {
        background: rgba(240, 245, 247, 0.6);
        border-bottom: 1px solid #cdcbcf;
    }

    .bl-bg:last-child, .bl-bg:first-child {
        border-bottom: none;
    }

    .bl-bg:first-child {
        border-top-right-radius: 10px;
    }

    .bl-bg:last-child {
        padding-bottom: 25px;
        border-bottom-right-radius: 10px;
    }
</style>
